import React from 'react';
import './mycarousel.css';
import { Link } from 'react-router-dom'; // Ensure react-router-dom is installed

export default function MyCarousel({ isActive, setIsActive }) {
    const options = {
    fade: true,
    accessibility: true,
    pageDots: false,
    loop: true,
    dots: false,
    setGallerySize: false,
    wrapAround: true,
    margin: 10,
    nav: false,
    autoplay: true,
    autoplayTimeout: 2000, // Set to 0 to disable initial timeout
    autoplaySpeed: 3000,
    autoplayHoverPause: false,
    prevNextButtons: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 5,
      },
    },
  };
  return (
    <div className="my-carousel-wrapper">
      <div
        id="premiumBusinessCarousel"
        className="carousel slide carousel-fade" // Added fade transition for premium look
        data-ride="carousel"
        data-interval="2000" // Custom timing for premium feel
      >
        {/* Indicators */}
        <ol className="carousel-indicators custom-indicators">
          <li data-target="#premiumBusinessCarousel" data-slide-to="0" className="active"></li>
          <li data-target="#premiumBusinessCarousel" data-slide-to="1"></li>
          <li data-target="#premiumBusinessCarousel" data-slide-to="2"></li>
          <li data-target="#premiumBusinessCarousel" data-slide-to="3"></li>
        </ol>

        {/* Carousel Inner */}
        <div className="carousel-inner">
          
          {/* Slide 1: DMT Group */}
          <div className="carousel-item active">
            <div className="slider-section slide-bg-1">
              <div className="overlay-slider"></div>
              <div className="slide-content container">
                <div className="content-badge">WELCOME TO DMT</div>
                <h1 className="slide-title main-heading">DMT Group</h1>
                <div className="slide-subtitle">
                  <span className="typed-text">Your Business Buddy</span>
                </div>
                <div className="accent-divider"></div>
                <p className="slide-caption">
                  The easiest way to upgrade, grow, and manage your business efficiently.
                </p>
                <div className="btn-wrapper">
                  <button
                    onClick={() => setIsActive(!isActive)}
                    className="btn btn-premium"
                  >
                    CONTACT US
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Slide 2: DMT Empire */}
          <div className="carousel-item">
            <div className="slider-section slide-bg-2">
              <div className="overlay-slider"></div>
              <div className="slide-content container">
                <div className="content-badge">FINANCIAL SOLUTIONS</div>
                <h1 className="slide-title">DMT EMPIRE INDIA PVT LTD</h1>
                <div className="slide-subtitle">
                  <span>The Easiest Way To Spend, Save & Manage Money</span>
                </div>
                <div className="accent-divider"></div>
                <p className="slide-caption">
                  We provide you with the best products and more than 25 diverse services at valuable prices—including Travel, Banking, Insurance, Utility, and CSP.
                </p>
                <div className="btn-wrapper">
                  <Link
                    to="https://dmtkendra.com/"
                    className="btn btn-premium"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    VISIT US
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Slide 3: Shardajeet Foundation */}
          <div className="carousel-item">
            <div className="slider-section slide-bg-3">
              <div className="overlay-slider"></div>
              <div className="slide-content container">
                <div className="content-badge">OUR NGO & INITIATIVE</div>
                <h1 className="slide-title">Shardajeet Foundation</h1>
                <div className="slide-subtitle">
                  <span>A helping hand for the underprivileged community</span>
                </div>
                <div className="accent-divider"></div>
                <p className="slide-caption">
                  A Social Service Organization working for welfare and empowerment. We provide essential resources like books, stationary, and scholarships to deserving students.
                </p>
                <div className="btn-wrapper">
                  <Link
                    to="https://shardajeetfoundation.org/"
                    className="btn btn-premium"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    VISIT US
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Slide 4: Finwelco */}
          <div className="carousel-item">
            <div className="slider-section slide-bg-4">
              <div className="overlay-slider"></div>
              <div className="slide-content container">
                <div className="content-badge">WEALTH MANAGEMENT</div>
                <h1 className="slide-title">Finwelco</h1>
                <div className="slide-subtitle">
                  <span>Specializing in Insurance, Mutual Funds, and Loan Services</span>
                </div>
                <div className="accent-divider"></div>
                <p className="slide-caption">
                  Whether you're planning for retirement, protecting your assets, or seeking investment opportunities, Finwelco is here to guide you every step of the way.
                </p>
                <div className="btn-wrapper">
                  <Link
                    to="https://finwelco.com/"
                    className="btn btn-premium"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    VISIT US
                  </Link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}